import React from "react";
import {Card, Col, Empty, InputNumber, Row, Statistic} from "antd";
import DashboardPageContainer from "./Dashboard.style";
import ArrowUpOutlined from "@ant-design/icons/es/icons/ArrowUpOutlined";
import ArrowDownOutlined from "@ant-design/icons/es/icons/ArrowDownOutlined";
import {Line, Pie} from '@ant-design/charts';
import GlobalOutlined from "@ant-design/icons/es/icons/GlobalOutlined";
import CopyrightOutlined from "@ant-design/icons/es/icons/CopyrightOutlined";
import useController from "./Dashboard.controller";

const lineChartConfig = {
    xField: 'year',
    yField: 'value',
    point: {
        size: 5,
        shape: 'diamond',
    },
    label: {
        style: {
            fill: '#aaa',
        },
    },
};

const pieChartConfig = {
    meta: {
        country: {
            alias: '国家',
            range: [
                0,
                1
            ]
        },
        value: {
            alias: '数量',
            formatter: v => {
                return `${v}`;
            }
        }
    },
    angleField: 'value',
    colorField: 'description'
};

const Dashboard = () => {
    const {
        registeredCompanyCount, activeLicenceCount, issuedLicenceCount,
        issueDaysToSubtractDefault, issueDaysToSubtract, expirationDaysThreshold, expiringLicenceCount, expirationDaysThresholdDefault,
        onIssuedDaysToSubtractChanged, onExpiringDaysToSubtractChanged,
        licencesBySoftwareProducts, licencesByYear
    } = useController();

    return <DashboardPageContainer>
        <div className="basic-header">
            <h3 className="basic-title">Dashboard</h3>
        </div>

        <Row gutter={[16, 16]}>
            <Col xs={24} sm={12}>
                <Card size={'small'}>
                    <Statistic title="Registered Company Count" value={registeredCompanyCount}
                               prefix={<GlobalOutlined/>}/>
                </Card>
            </Col>
            <Col xs={24} sm={12}>
                <Card size={'small'}>
                    <Statistic
                        title="Active Licence Count"
                        value={activeLicenceCount}
                        valueStyle={{color: '#3f8600'}}
                        prefix={<ArrowUpOutlined/>}
                    />
                </Card>
            </Col>
        </Row>
        <br/>

        <Row gutter={[16, 16]}>
            <Col xs={24} sm={12}>
                <Card size={'small'}>
                    <Statistic title={<div>
                        Issued Licence Count in last
                        <InputNumber className='issue-days' min={1} max={3000} value={issueDaysToSubtract}
                                     defaultValue={issueDaysToSubtractDefault}
                                     onChange={onIssuedDaysToSubtractChanged}/> days
                    </div>} value={issuedLicenceCount} prefix={<CopyrightOutlined/>}/>
                </Card>
            </Col>
            <Col xs={24} sm={12}>
                <Card size={'small'}>
                    <Statistic
                        title={<div>
                            Licence Count to Expire in next
                            <InputNumber className='issue-days' min={1} max={3000} value={expirationDaysThreshold}
                                         defaultValue={expirationDaysThresholdDefault}
                                         onChange={onExpiringDaysToSubtractChanged}/> days
                        </div>}
                        value={expiringLicenceCount}
                        valueStyle={{color: '#cf1322'}}
                        prefix={<ArrowDownOutlined/>}
                    />
                </Card>
            </Col>
        </Row>
        <br/>

        <Row gutter={[16, 16]}>
            <Col xs={24} lg={12}>
                <Card title='Licence Count by Year'>
                    {
                        licencesByYear.length ? <Line {...lineChartConfig} data={licencesByYear} /> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    }
                </Card>
            </Col>
            <Col xs={24} lg={12}>
                <Card title='Purchased Licences Share' className='product_share_pie_card'>
                    {
                        licencesBySoftwareProducts.length ? <Pie height={250} {...pieChartConfig} data={licencesBySoftwareProducts} /> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    }
                </Card>
            </Col>
        </Row>
    </DashboardPageContainer>
};

export default Dashboard;